import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AgreementComponent } from '../agreement/agreement.component';
import { AppService } from '../services/app.service';
import { Feeding } from '../wizard/wizard.component';
import Swal from 'sweetalert2/dist/sweetalert2.js';

import { InfoService, petKeyInfo, questions } from '../services/info.service';
import { TableComponent } from '../table/table.component';
import { CardOnFileComponent } from '../card-on-file/card-on-file.component';
import { MatStepper } from '@angular/material/stepper';
import { DatePipe } from '@angular/common';
import { AddImmunizationComponent } from '../add-immunization/add-immunization.component';

interface Food {
  value: string;
  viewValue: string;
}
export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

export interface Medication {
  name: string;
  position: number;
  med: string;
  unit: string;
  amount: string;
}
const ELEMENT_DATA2 = [
  { position: 1, name: 'Break Fast', med: 'med', unit: 'H', amount: '' },
  { position: 2, name: 'PM', med: 'med', unit: 'H', amount: '' },
  { position: 2, name: 'AM', med: 'med', unit: 'H', amount: '' },
];
const ELEMENT_DATA: PeriodicElement[] = [
  { position: 1, name: 'Break Fast', weight: 1.0079, symbol: 'H' },
  { position: 2, name: 'Lunch', weight: 4.0026, symbol: 'He' },
  { position: 3, name: 'Dinner', weight: 6.941, symbol: 'Li' },
];


@Component({
  selector: 'app-dialog-pop-up',
  templateUrl: './dialog-pop-up.component.html',
  styleUrls: ['./dialog-pop-up.component.css']
})
export class DialogPopUpComponent implements OnInit, OnChanges {
  // constructor(private _formBuilder: FormBuilder, public infoService:InfoService,public dialog: MatDialog) {


  constructor(private _formBuilder: FormBuilder, private matDialog: MatDialog, public infoService: InfoService, public appService: AppService) {
    console.info("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$4Stepper 4 init$$$$$$$$$$$$$$$$$$$$$$$$$$$$$444");

  }
  @ViewChild('stepper') stepper!: MatStepper;
  @Output() enableReq = new EventEmitter<boolean>();
  @ViewChild('petFeed') TableFeed: TableComponent;
  @ViewChild('petMed') TableMed: TableComponent;
  @ViewChild('ownerCard') Tablecard: TableComponent;

  petFeedDone = 0;
  petMedDone = 0;
  cardDone = 0;

  ForceStepperControl = this.infoService.ForceStepperControl;

  showData() {
    this.infoService.forceCheck();
    console.log(this.infoService.petKey)
    console.log(this.infoService.ForceStepperControl);
  }

  changeStepper() {
    this.stepper.next();
  }

  sendEnableReq() {
    let forceObj = this.infoService.ForceStepperControl;

    if (forceObj.ForceFeeding == true && this.petFeedDone <= 0) {
      return;
    }
    if (forceObj.ForceMedication == true && this.petMedDone <= 0) {
      return;
    }
    if (forceObj.ForceCardOnFile == true && this.cardDone <= 0) {
      console.log("disable");

      this.enableReq.emit(false);
      return;
    }
    this.enableReq.emit(true);
  }

  petMedCheck(event: number) {
    this.petMedDone = event;
    if (event > 0) {
      this.sendEnableReq();
    }
  }
  petFeedCheck(event: number) {
    this.petFeedDone = event;
    if (event > 0) {
      this.sendEnableReq();
    }
  }
  cardCheck(event: number) {
    this.cardDone = event;
    if (event > 0) {
      this.sendEnableReq();
    } else {
      this.enableReq.emit(false);

    }
  }

  dataSource = ELEMENT_DATA;
  medication = ELEMENT_DATA2;
  isLinear = false;
  size: number = 0;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  feedingFormGroup: FormGroup;

  dataSourceForAgreement: any[] = []
  @Input() agreements: any[] = []
  @Input() petOwnersAgreements:any[] = []
  @Input() qrCodeData: any
  displayedColumnsForAgreements: string[] = ['name', 'signed date', 'expiration date', 'status', 'action'];

  @Input() agreementPassCheck: boolean

  @Output() submitted = new EventEmitter()

  @Input() immunizationsForPets: any[] = []

  @Input() immunizationPassCheck: boolean

  @Input() showImmunization: boolean

  @Input() showAgreementForSign: boolean

  displayedColumnsForImmunizations: string[] = ['name', 'expiry date', 'status', 'service', 'action'];

  // petMedCheck(event: number) {
  //   this.petMedDone = event;
  // }

  @Output() submitForImmunization = new EventEmitter()

  AddCard = {
    applicationReturnUrl: '',
    customPaymentUrl:'',
    invoiceVo: {
      customerVO: {
        email: '',
        firstName: '',
        mobileNumber: '',
        userKey: ''
      }
    }
  }

  OpenAddCardDialog() {

    this.AddCard.invoiceVo.customerVO.email = localStorage.getItem('email')? localStorage.getItem('email').replace(/['"]/g, '') : undefined;
    this.AddCard.invoiceVo.customerVO.firstName = localStorage.getItem('userName')? localStorage.getItem('userName').replace(/['"]/g, ''): undefined;
    this.AddCard.invoiceVo.customerVO.mobileNumber = localStorage.getItem('no')? localStorage.getItem('no').replace(/['"]/g, '') : undefined;
    this.AddCard.invoiceVo.customerVO.userKey = localStorage.getItem('userKey')? localStorage.getItem('userKey').replace(/['"]/g, '') : undefined;
    this.AddCard.customPaymentUrl = this.appService.applicationReturnUrl + "/"+this.appService.tenantKey +"/addcard.html";
    console.log(this.AddCard);

    this.infoService.AddCard(this.AddCard).subscribe((res: any) => {
      console.log(res);
      if (!res.data.hasOwnProperty('addCardUrl')) {
        alert("Add Card Failure Download Mobile App");
        return;
      }
      let link = res.data.addCardUrl;
      let data ={
        link : res.data.addCardUrl,
        isRequestDeposit : false
      }
      const dialogRef = this.matDialog.open(CardOnFileComponent, {
        height: '680px', data: data, disableClose: true
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        this.Tablecard.getCard();
      })

    })

  }

  displayedColumns: string[] = ['name', 'weight', 'unit', 'description'];
  displayedColumns2: string[] = ['name', 'med', 'unit', 'amount', 'description'];
  petsInfo: petKeyInfo[];
  petSpecificQuestions: questions;
  petQuestions: Map<string, questions[]>;
  currentPetName: string = "";
  currentpetIndex: number = 0;
  questionAnswered: boolean = false;
  ForceQuestion:boolean=false;

  @Output() questionAnsweredEvent = new EventEmitter();

  emitQAStatus(questionAnswered:boolean){
    this.questionAnsweredEvent.emit(questionAnswered);
  }
  ansNextPet(petQuestions: Map<string, questions[]>) {
    let answered = true;
    petQuestions.forEach((value, key) => {
      value.forEach((question) => {
        if (!question.answer) {
          answered = false;
          this.emitQAStatus(!answered)
          this.questionAnswered = false;
          Swal.fire({
            title: 'Answer all the questions',
            // text: "Changes Not Saved",
            icon: 'warning',
            confirmButtonColor: 'red',
          })

        }
      })
    })

    if (answered) {
      this.currentpetIndex = this.petsInfo.findIndex(pet => pet.name == this.currentPetName);
      if (this.currentpetIndex == this.petsInfo.length - 1) {
        this.questionAnswered = true;
        this.emitQAStatus(!this.questionAnswered)
        this.stepper.next();
      } else {
        this.questionAnswered = false;
        this.emitQAStatus(!this.questionAnswered);
        this.currentPetName = this.petsInfo[this.currentpetIndex+1].name;
        this.petQuestions = this.petsInfo[this.currentpetIndex+1].answers;
      }
    }
  }

  petSelectedForQuestion(petName) {
   
    this.currentPetName = petName;
    this.petQuestions = this.petsInfo.find(pet => pet.name == petName).answers;
  }

  log() {
    console.log(this.petsInfo);
    const stepsCount = this.stepper._steps.length;
    const nextIndex = 2; 
    if (nextIndex >= 0 && nextIndex < stepsCount) {
      this.stepper.selectedIndex = nextIndex;
    } 
    // this.stepper.selectedIndex = 2;

  }
  prevPageSubmitAction() {
    console.log('Confirm Clicked got it');
    this.petsInfo = this.infoService.getPetInfo();
    let forceQuestion = false;
    if (this.petsInfo.length > 0) {
      this.ForceQuestion = this.petsInfo.some(pet=>{
          if(pet.answers.size > 0){
            return true;
          }
          return false;
      } )
      console.log(this.ForceQuestion, "force question");
      
      this.emitQAStatus(this.ForceQuestion);
      if(this.ForceQuestion){
        this.currentPetName = this.petsInfo[0].name;
        this.petQuestions = this.petsInfo[0].answers;
      }
    }
    // this.infoService.forceCheck();
    this.ForceStepperControl = this.infoService.ForceStepperControl;
  }

  showAgreement(data: any) {
    let dialogRef = this.matDialog.open(AgreementComponent, {
      // height: '70%',
      width: '80%',
      data: data,
      disableClose: true,
      height : '90%'
    })

    dialogRef.componentInstance.submitted.subscribe((value: any) => {
      data.status = "SIGNED"
      this.submitted.emit(true)
    })
  }

  intialCheck() {
    console.log("intialCheck");
    this.TableFeed.getPetFeed(0);
    this.TableMed.getPetMed(0);
    this.Tablecard.getCard();
  }
  swalReturn = false;

  checkAllQuestionsAnswered() {
    console.log("checking question");
    let answered = true;
    this.petsInfo.forEach((pet) => {
      pet.answers.forEach((value, key) => {
        value.forEach((question) => {
          if (!question.answer) {
            answered = false;
          }
        })
      })
    })
    return answered;
  }



  selectionChange(event: any, stepper: MatStepper) {
    // console.log(event.selectedStep.label, stepper,this.TableFeed.swallSaveControl, this.TableMed.swallSaveControl);

    let current = this.stepper.selectedIndex;
  
    // Question validation 
    if (event.previouslySelectedStep.label == "Questions") {
      let answered = this.checkAllQuestionsAnswered();
      if (!answered) {
        this.questionAnswered = false;
        this.emitQAStatus(!this.questionAnswered)

        Swal.fire({
          title: 'Answer all the questions',
          // text: "Changes Not Saved",
          icon: 'warning',
          confirmButtonColor: 'red',
        }).then((result) => {

          if (result.isConfirmed) {
            // this.TableFeed.swallSaveControl = false;
            // this.stepper.selectedIndex = current;
            const stepsCount = this.stepper._steps.length;
            if (current >= 0 && current < stepsCount) {
              this.stepper.selectedIndex = current;
            } 
          } else {
            this.swalReturn = true;
            // this.stepper.selectedIndex = current;
            const stepsCount = this.stepper._steps.length;
            if (current >= 0 && current < stepsCount) {
              this.stepper.selectedIndex = current;
            } 
            return;
          }
        })
      }else{
        this.questionAnswered = true;
        this.emitQAStatus(!this.questionAnswered)
      }
      return;
    }


    // stepper change unsave check 
    if (this.infoService.ForceStepperControl.ForceFeeding && this.TableFeed.swallSaveControl) {

      Swal.fire({
        title: 'Changes Not Saved',
        // text: "Changes Not Saved",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'red',
        cancelButtonColor: '#41A049',
        confirmButtonText: 'I know '
      }).then((result) => {

        if (result.isConfirmed) {
          this.TableFeed.swallSaveControl = false;
          // this.TableMed.swallSaveControl =false;

        } else {
          this.swalReturn = true;
          this.TableFeed.swallSaveControl = false;
          // this.TableMed.swallSaveControl=false;
          // this.stepper.selectedIndex = current;
          const stepsCount = this.stepper._steps.length;
          if (current >= 0 && current < stepsCount) {
            this.stepper.selectedIndex = current;
          } 
          return;
        }

      })

    }
    if (this.infoService.ForceStepperControl.ForceMedication && this.TableMed.swallSaveControl) {

      Swal.fire({
        title: 'Changes Not Saved',
        // text: "Changes Not Saved",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'red',
        cancelButtonColor: '#41A049',
        confirmButtonText: 'I know '
      }).then((result) => {

        if (result.isConfirmed) {
          // this.TableFeed.swallSaveControl = false;
          this.TableMed.swallSaveControl = false;

        } else {
          this.swalReturn = true;
          // this.TableFeed.swallSaveControl = false;
          this.TableMed.swallSaveControl = false;
          // this.stepper.selectedIndex = current;
          const stepsCount = this.stepper._steps.length;
          if (current >= 0 && current < stepsCount) {
            this.stepper.selectedIndex = current;
          } 
          return;
        }

      })

    }
    if (!this.swalReturn) {

      if (event.selectedStep.label == 'Feed') {
        this.TableFeed.getPetFeed(0);
      } else if (event.selectedStep.label == 'Med') {
        this.TableMed.getPetMed(0);
      } else if (event.selectedStep.label == 'Cof') {
        this.Tablecard.getCard();
      }

    }

    this.swalReturn = false;

  }

  requestFeedApi() {
    console.log('fetching');
  }

  showAgreements(agreements: any[]): boolean {
    if (agreements.length > 0) {

      return true
    }

    return false
  }

  showImmunizations(immunizations: any[]): boolean {
    if (immunizations.length > 0) {

      return true
    }

    return false
  }

  formatDate(date: any, format: any) {
    let datePipe = new DatePipe('en-US')

    return datePipe.transform(date, format)
  }

  showAddImmunizationDialog(data) {
    let dialogRef = this.matDialog.open(AddImmunizationComponent, {

      disableClose: true,
      data: data
    })

    dialogRef.componentInstance.submitted.subscribe((immunization: any) => {
      this.submitForImmunization.emit(immunization)
    })
  }

  ngOnInit() {
    // this.getImmunizations()
  }

  ngOnChanges(changes: SimpleChanges): void {

  }
}
